/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { useOrgId } from '../provider';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { REMOVE_ACCESS } from '../../api/graphql';
import moment from 'moment-timezone';

import { vappContainer } from '@/application';
import { notificationConfig } from '../../config/notifications.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

const LoginPageServ = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface RemoveAccessProps {}
export interface IRemoveAccessMethods extends IPluginMethodMap {
  removeAccess(args: RemoveAccessProps): Promise<any>;
}
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export class RemoveAccessService implements IAgentPlugin {
  readonly methods: IRemoveAccessMethods;

  constructor() {
    this.methods = {
      removeAccess: this.removeAccess.bind(this),
    };
  }

  async removeAccess(args: RemoveAccessProps) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    console.log(`args in invite user service`, args);
    try {
      if (client) {
        const res = await client
          .mutation(
            REMOVE_ACCESS,

            { ...args }
          )
          .toPromise();

        if (res?.data?.deactivateAccount) {
          console.log(`table data`, res);
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
